// src/styles.css.js
export const PANEL_STYLES = `
.attraxion-backdrop {
  position: fixed; inset: 0; background: rgba(15,23,42,.45);
  z-index: 2147483646; opacity: 0; transition: opacity .22s ease-out;
  pointer-events: none;
}
.attraxion-backdrop[data-open="true"] { opacity: 1; pointer-events: auto; }

.attraxion-panel {
  position: fixed; top: 0; right: 0; height: 100%; width: 440px; max-width: 100vw;
  background: #fff; box-shadow: -12px 0 32px rgba(0,0,0,.18);
  transform: translateX(100%); transition: transform .22s ease-out;
  z-index: 2147483647; display: flex; flex-direction: column;
}
.attraxion-panel[data-open="true"] { transform: translateX(0); }
.attraxion-panel iframe { width: 100%; height: 100%; border: 0; }

@media (max-width: 640px) {
  .attraxion-panel { width: 100vw; }
}

.attraxion-trigger {
  appearance: none; border: 0; cursor: pointer;
  padding: 10px 18px; border-radius: 8px;
  font: 600 14px/1 system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  color: #fff; background: var(--attraxion-color, #6366f1);
}
.attraxion-trigger:focus-visible { outline: 2px solid #000; outline-offset: 2px; }
`;
